// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"6e09d9af","348":"a02e85d3","571":"a20c4f4c","924":"88e1fa51"}[chunkId] + ".chunk.js";
};